
import {post} from '@/utils/request';
import {erpserver,oaserver,erpplatserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//搜索树
export async function selectDictPz(params) {
    return post(erpserver+'/zxType/selectDictPz', params, true)
}

//仓库下拉
export async function selectWarehouse(params) {
    return post(erpserver+'/storekq/selectWarehouse', params, true)
}
//获取仓库列表
export async function getWarehouseList(params) {
    return post(oaserver+'/oacurrency/getWarehouseList', params, true);
}
//保存
export async function saveZXType(params) {
    return post(erpserver+'/zxType/saveZXType', params, true)
}
//列表
export async function zxTypeList(params) {
    return post(erpserver+'/zxType/zxTypeList', params, true)
}
//根据id查询已有产品
export async function pDetailList(params) {
    return post(erpserver+'/zxType/pDetailList', params, true)
}
//产品树
export async function getProductTree(params) {
    return post(erpplatserver+'/systemtree/getProductTree', params, true)
}
//保存产品列表
export async function savePDetail(params) {
    return post(erpserver+'/zxType/savePDetail', params, true)
}

